<template>
    <section v-if="!list_loading && !htp_importing">
        <div class="row">
            <div class="col-12 mb-2">
                <div class="card shadow position-relative list">
                    <div class="p-2">
                        <div class="card-body">
                            <div class="mb-1 mt-2">
                                <h1 class="h1 mb-0 text-black text-center page-title">{{list.name}}</h1>
                            </div>
                            <p v-if="list.notes" class="text-center mt-3">{{list.notes}}</p>
                            <div class="row">
                                <div class="col-md-10">
                                    <div v-if="list.delivery_personal">
                                        <i class="fa-solid fa-check text-success"></i>
                                        Livrare personală <b>gratuită</b> în {{list.delivery_personal_location}}
                                    </div>
                                    <div v-if="list.delivery_courier">
                                        <i class="fa-solid fa-check text-success"></i>
                                        Livrare prin curier {{list.delivery_courier_cost=="free"?"gratuită":"suportată de cumpărator" }} în {{list.delivery_courier_location}}
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="text-right">
                                        <template v-if="getContactType()">
                                            <div>
                                            <button class="btn btn-primary btn-success text-uppercase" type="button" v-on:click="clickContact()">
                                                <span v-show="getContactType()=='phone'"><i class="fa-brands fa-whatsapp text-white"></i></span>
                                                <span v-show="getContactType()=='email'"><i class="fa-regular fa-envelope text-white"></i></span>
                                                <span v-show="getContactType()=='link'"><i class="fa-solid fa-arrow-up-right-from-square text-white"></i></span>
                                                Contact
                                            </button>
                                            </div>
                                            <div><span>{{list.contact}}</span></div>
                                        </template>
                                        <span v-else>Contact: {{list.contact}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="color-scale">
                        <div class="min h2 text-white pl-2 mt-2 mt-md-0"><i class="h6 fa-solid fa-thumbs-up"></i></div>
                        <div class="max h2 text-white pr-2 mt-2 mt-md-0"><i class="h6 fa-solid fa-medal"></i></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="scrolled"></div>

        <div class="clearfix">

            <div class="float-md-right text-right mt-md-2 mb-2 mr-1 mr-md-0">
                Sortare
                <button @click="sortList('default')" v-tooltip="'Sortare implicită'" class="btn btn-secondary btn-sm ml-2 py-0 px-2 fs-6" :class="{'btn-success': sorted_by=='default'}" type="button"><i class="fa-solid fa-face-smile"></i></button>
                <button @click="sortList('alphabetical')" v-tooltip="'Sortează lista alfabetic'" class="btn btn-secondary btn-sm ml-2 py-0 px-2 fs-6" :class="{'btn-success': sorted_by=='alphabetical'}" type="button"><i class="fa-solid fa-font"></i></button>
                <button @click="sortList('rating')" v-tooltip="'Sortează lista după nota de pe BGG'" class="btn btn-secondary btn-sm ml-2 py-0 px-1 fs-6" :class="{'btn-success': sorted_by=='rating'}" type="button"><i class="fa-solid fa-star"></i></button>
                <button @click="sortList('price')" v-tooltip="'Sortează lista după preț'" class="btn btn-secondary btn-sm ml-2 py-0 px-2 fs-6" :class="{'btn-success': sorted_by=='price'}" type="button"><i class="fa-solid fa-sack-dollar"></i></button>
                <button @click="sortList('discount')" v-tooltip="'Sortează lista după reducere'" class="btn btn-secondary btn-sm ml-2 py-0 px-2 fs-6" :class="{'btn-success': sorted_by=='discount'}" type="button"><i class="fa-solid fa-percent"></i></button>
            </div>
            <div class="float-md-left text-center mb-2 ml-1 ml-md-0 mr-1">
                <div class="float-md-left">
                    <input v-model="filters.search" type="text" class="form-control bg-white small border" :class="{'border-warning': filters.search}" placeholder="Caută în listă" maxlength="150">  
                </div>
                <div v-if="filters.search" class="float-md-left ml-1 mt-3 text-warning">
                    <div class="d-inline h4 d-none d-md-inline"><i class="fa-solid fa-turn-down"></i></div>
                    <div class="d-inline h4 d-md-none" ><i class="fa-solid fa-down-long"></i></div>
                </div>
            </div>
        </div>
       
        <!-- Content Row -->
        <div v-for="(game, i) in games" :key="games[i].id" :bgg-id="games[i].id">
            <view-item :item="game" :index="i" :filters="filters"></view-item>
        </div>

        <div v-show="scrolled" class="toTop z-1000" @click="scrollToTop" v-tooltip="'înapoi sus'"><img src="/img/meeple.svg"></div>

        <!-- Modal -->
            <div class="modal fade" id="imageModal" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header bg-header text-white">
                            <h5 class="modal-title" id="exampleModalLabel">{{image_modal.title}}</h5>
                            <button type="button" class="btn-close bg-white" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <a :href="image_modal.src" target="_blank">
                                <img :src="image_modal.src" class="w-100" alt="" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
    </section>
    <div v-else class="loading"><span></span><p>{{list_loading?'tragem lista...':''}}{{htp_importing?'verificăm prețuri...':''}}</p></div>
</template>
<script>
    import Vue from "vue";
    import HelperMixin from "../../mixins/HelperMixin";
    import ViewItem from '../ViewItem'
    import VTooltip from 'v-tooltip'

    Vue.use(VTooltip);

    export default {
        name: "ViewList",
        components: { ViewItem },
        mixins: [HelperMixin],
        props: ['list_id'],
        computed: { },
        data() {
            return {
                list_loading: true,
                htp_importing: false,
                offsetTop: 0,
                scrolled: false,
                filters: { search: '' },
                games: [],
                list: { id: null, edit_id: null, name: '', contact: '', notes: '', delivery_personal:true, delivery_personal_location:'', delivery_courier: true, delivery_courier_location:'', delivery_courier_cost:'free'}
            }
        },
        mounted() {
            var _this = this;
            
            this.getList(_this.list_id);

            if(window.mixpanel) {
                window.mixpanel.track('ViewList', {list_id: _this.list_id});
            }

            window.addEventListener('scroll', this.onScroll);
        },
        watch: {
            offsetTop (val) {
               this.scrolled = this.isElementScrolledBy(document.querySelectorAll(".scrolled")[0])
            }
        },
        methods: {
            
            getList: function (list_id) {
                var _this = this;
                $.ajax({
                    type: "POST",
                    url: api_url+'/list/get',
                    dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ id: list_id })
                }).always(function(data){
                    if(typeof data.id != "undefined") {
                        _this.list = JSON.parse(data.details);
                        _this.games = JSON.parse(data.games);
                        document.title = _this.list.name+' | '+app_name;    

                        let game_ids = _this.games.map((game) => game.id); 

                        _this.list_loading = false;
                        _this.htp_importing = true;

                        _this.getHTPData(game_ids); 
                    } else {
                        _this.$router.push({ name: "home" }).catch(err => {});
                    }
                });
            },

            clickContact: function () {
                var _this = this;
                var type = _this.getContactType();
                var contact = _this.list.contact.trim();
                var link = '';

                switch(type) {
                    case 'phone':
                        link = 'https://wa.me/'+_this.formatPhoneNumber(contact);
                        break;
                    case 'email':
                        link = 'mailto:'+contact;
                        break;
                    case 'link':
                        link = contact;
                        break;
                }

                if(window.mixpanel) {
                    window.mixpanel.track('ClickContact', {list_id: _this.list_id});
                }

                window.open(link, "_blank");
            }

        }
    };
</script>
